type ServerEnv = 'develop' | 'production'

export const PROJECT_ENV = process.env.REACT_APP_SERVER_ENV as ServerEnv

export const isProdEnv = PROJECT_ENV === 'production'

export const API_BASE_URL = isProdEnv ? 'https://api.nxkbapp.com' : 'https://api.dev.nxkbapp.com'
// export const API_BASE_URL = 'http://127.0.0.1:2022'
